<script setup lang="ts">
defineProps<{
  total: number
  current: number
}>()
</script>

<template>
  <ul class="flex items-center gap-2">
    <li
      v-for="n in total"
      :key="n"
      class="grid size-4 place-items-center rounded-full text-center text-xxs-8px-default transition"
      :class="{
        'bg-background-black text-text-inverted': n === current,
        'bg-background-gray-subtle text-text-subtlest': n !== current,
      }"
    >
      {{ n }}
    </li>
  </ul>
</template>
